import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { DataService } from '../../../core/service/base/data.service';
import { APP_CONFIG, IAppConfig } from './../../../app.config';
import { Observable, of } from 'rxjs';
import { map, shareReplay } from 'rxjs/operators';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { MessageService } from '../../../core/service/message.service';
import { ArticleGroup } from '../../model/article-group';
import { AutoCompleteSelectionItem } from '../../../core/component/autocomplete-remote/autocomplete-selection-item';
import { AutoCompleteSelectionState, IAutoCompleteService } from '../../../core/component/autocomplete-remote/autocomplete-service.interface';

@Injectable()
export class ArticleGroupService extends DataService<ArticleGroup> implements IAutoCompleteService<ArticleGroup> {
  private selectionItems: Observable<AutoCompleteSelectionItem<ArticleGroup>[]>;

  constructor(client: HttpClient, @Inject(APP_CONFIG) config: IAppConfig, messageService: MessageService, progressBar: ProgressBarService) {
    super(client, config, messageService, ArticleGroup, progressBar, 'article-group');
  }

  createAutoCompleteSelectionItem(data: ArticleGroup): AutoCompleteSelectionItem<ArticleGroup> {
    return new AutoCompleteSelectionItem(data.name, data.id, data);
  }

  getSelectionItem(id: string, _state: AutoCompleteSelectionState<ArticleGroup>): Observable<AutoCompleteSelectionItem<ArticleGroup>> {
    return this.getArticleGroupSelections().pipe(map(items => items.find(item => item.value === id)));
  }

  getSelection(filter: string, _options?: any, page: number = 1): Observable<AutoCompleteSelectionItem<ArticleGroup>[]> {
    if (page > 1) {
      return of([]);
    }

    const searchText = filter === '*' ? '' : (filter || '').trim().toLocaleLowerCase();
    return this.getArticleGroupSelections().pipe(
      map(items => (searchText ? items.filter(item => item.name.toLocaleLowerCase().includes(searchText)) : items))
    );
  }

  private getArticleGroupSelections(): Observable<AutoCompleteSelectionItem<ArticleGroup>[]> {
    if (!this.selectionItems) {
      this.selectionItems = this.getList().pipe(
        map(items => items.map(item => this.createAutoCompleteSelectionItem(item))),
        shareReplay(1)
      );
    }
    return this.selectionItems;
  }
}
